import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { SHOP } from 'config/fe-routes';
import React from 'react';
import { Trans } from 'react-i18next';
import { palette } from 'themes/default';
import { redirectTo } from 'utils/route-helpers';

type Props = {
  shopSlug: string;
};

export const AutomaticFeedbackBanner = ({ shopSlug }: Props) => (
  <div
    style={{
      background: '#EEF3FF',
      borderRadius: '8px',
      padding: '5px 16px',
      minHeight: '30px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    }}
  >
    <InfoOutlinedIcon style={{ fontSize: 20, color: palette.colorGray100, flexShrink: 0 }} />
    <span style={{ fontSize: '14px', color: palette.colorGray100, letterSpacing: '0.2px' }}>
      <Trans i18nKey="components.feedback.automatic-feedback-sent">
        {'Automatic feedback sent. Check it '}
        <button
          onClick={() => redirectTo({ ...SHOP(shopSlug), query: { tab: 'reviews' } })}
          style={{
            fontWeight: 600,
            textDecoration: 'underline',
            cursor: 'pointer',
            color: 'inherit',
            background: 'none',
            border: 'none',
            padding: 0,
            font: 'inherit',
          }}
        >
          here
        </button>
      </Trans>
    </span>
  </div>
);
